import { importProvidersFrom } from '@angular/core';

import { ApiResourceModule } from './shared/api-resource/api-resource.module';
import { AuthenticationModule } from './shared/authentication/authentication.module';
import { CertificateResourceModule } from './shared/certificate-resource/certificate-resource.module';
import { CourseResourceModule } from './shared/course-resource/course-resource.module';
import { DownloadServiceModule } from './shared/download-service/download.module';
import { ErrorReporterModule } from './shared/error-reporter/error-reporter.module';
import { PresubscriptionResourceModule } from './shared/presubscription-resource/presubscription-resource.module';
import { SeasonResourceModule } from './shared/season-resource/season-resource.module';
import { StatsResourceModule } from './shared/stats-resource/stats-resource.module';
import { UsersResourceModule } from './shared/users-resource/users-resource.module';

/**
 * Global providers imported from modules.
 * Used in main.ts and can be reused in tests.
 */
export const GLOBAL_MODULE_PROVIDERS = importProvidersFrom(
  ApiResourceModule,
  ErrorReporterModule,
  AuthenticationModule,
  SeasonResourceModule,
  PresubscriptionResourceModule,
  CourseResourceModule,
  UsersResourceModule,
  StatsResourceModule,
  CertificateResourceModule,
  DownloadServiceModule,
);
